import type { EntityType } from '@/shared/types/company.types';

const SESSION_ENTITY_KEY = 'onapila_entity_type';

export function saveEntityType(entityType: EntityType) {
  localStorage.setItem(SESSION_ENTITY_KEY, entityType);
}

export function getEntityType(): EntityType | null {
  const v = localStorage.getItem(SESSION_ENTITY_KEY);
  return v as EntityType | null;
}
